import React from "react";
import { Box, Grid } from "@mui/material";
import { ProductItemTableOrder } from "./ProductItemTableOrder";
import { ProductItemXL } from "./ProductItemXL";
import { ProductItemSm } from "./ProductItemSm";
import moment from "moment";

export const ProductListTableOrder = (props) => {
  const {
    onOpen,
    products,
    menuDirection,
    selectedProd,
    ApplyTakeOutDeliveryPrice,
    orderType,
  } = props;

  const checkDisability = (product) => {
    const {
      disableondate,
      disableonday,
      disableontime,
      disablefromtime,
      disabletotime,
      disablefromdate,
      disabletodate,
      disableday,
    } = product;
    let currentTime = new Date().getTime();
    let currentDay = new Date().getDay();
    let startTime = new Date(disablefromtime).getTime();
    let endTime = new Date(disabletotime).getTime();
    let startDate = new Date(disablefromdate).getTime();
    let endDate = new Date(disabletodate).getTime();
    if (disableondate || disableonday || disableontime) {
      if (disableontime && currentTime > startTime && endTime > currentTime) {
        return true;
      } else if (
        disableonday &&
        disableday?.split("|").includes(`${currentDay}`)
      ) {
        return true;
      } else if (
        disableondate &&
        currentTime > startDate &&
        endDate > currentTime
      ) {
        return true;
      }
      return false;
    }
    return false;
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "row",
        overflowY: "auto",
      }}
    >
      <Grid
        container
        spacing={1}
        sx={{
          display: "flex",
          justifyContent: { xs: "center", md: "flex-start" },
        }}
      >
        {products.map((product) => {
          let price = product.price;
          var specialPrice = product.productSpecialPricings.find(
            (x) => x.fromQty === 1
          );
          if (specialPrice) {
            price = specialPrice.specialPrice;
          }
          return (
            <ProductItemSm
              key={product.productName + product.productId}
              id={product.productId}
              name={product.productName}
              description={product.productDescription}
              price={price || 0}
              imageUrl={product.imageUrl ? product.imageUrl : product.imageUrl2}
              onOpen={async () => await onOpen(product.productId)}
              selectedProd={selectedProd}
              ApplyTakeOutDeliveryPrice={ApplyTakeOutDeliveryPrice}
              orderType={orderType}
              deliveryprice={product.deliveryprice}
              takeoutprice={product.takeoutprice}
              pricedesc={product.pricedesc}
              isPizza={product.isPizza}
              isDisable={checkDisability(product)}
            />
          );
        })}
      </Grid>
    </Box>
  );
};
